export default "__VITE_ASSET__Bo_Sp0hw__"